var _path, _line, _line2, _path2, _line3, _line4, _path3, _line5, _line6, _path4, _path5, _path6, _path7, _rect, _rect2, _path8, _path9, _path10, _path11, _path12, _path13, _rect3, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPanel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 32 32",
    id: "meeting",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fbde53",
    d: "M8.5,3.5h-7a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1H2.821a1,1,0,0,1,.85.474l.478.772a1,1,0,0,0,1.7,0l.478-.772a1,1,0,0,1,.85-.474H8.5a1,1,0,0,0,1-1v-4A1,1,0,0,0,8.5,3.5Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    x2: 7.5,
    y1: 7.5,
    y2: 7.5,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    x2: 7.5,
    y1: 5.5,
    y2: 5.5,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed456a",
    d: "M30.5,3.5h-7a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h1.321a1,1,0,0,1,.85.474l.478.772a1,1,0,0,0,1.7,0l.478-.772a1,1,0,0,1,.85-.474H30.5a1,1,0,0,0,1-1v-4A1,1,0,0,0,30.5,3.5Z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 24.5,
    x2: 29.5,
    y1: 7.5,
    y2: 7.5,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 24.5,
    x2: 29.5,
    y1: 5.5,
    y2: 5.5,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#82c8ec",
    d: "M19.5.5h-7a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h1.321a1,1,0,0,1,.85.474l.478.772a1,1,0,0,0,1.7,0l.478-.772a1,1,0,0,1,.85-.474H19.5a1,1,0,0,0,1-1v-4A1,1,0,0,0,19.5.5Z"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 13.5,
    x2: 18.5,
    y1: 4.5,
    y2: 4.5,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 13.5,
    x2: 18.5,
    y1: 2.5,
    y2: 2.5,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd9aa",
    d: "M19.5,14a3.5,3.5,0,0,1-7,0,1.769,1.769,0,0,1,.01-.23,3.5,3.5,0,0,1,6.97-.15C19.49,13.75,19.5,13.87,19.5,14Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#57565d",
    d: "M19.48,13.62,19,13.5l-2.86-.81a2,2,0,0,0-1.3.07L13,13.5l-.49.27a3.5,3.5,0,0,1,6.97-.15Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed456a",
    d: "M17.5,19.5h0a5,5,0,0,1,5,5v4H9.5v-4a5,5,0,0,1,5-5h3Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd9aa",
    d: "M17.5,16.5V19A1.5,1.5,0,0,1,16,20.5h0A1.5,1.5,0,0,1,14.5,19V16.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 4,
    x: 2.5,
    y: 19.5,
    fill: "#ffd9aa"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 4,
    x: 26.5,
    y: 19.5,
    fill: "#ffd9aa"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd9aa",
    d: "M7.5,17A3.492,3.492,0,0,1,.85,18.5H.84A3.406,3.406,0,0,1,.5,17a3.5,3.5,0,0,1,6.69-1.43A3.432,3.432,0,0,1,7.5,17Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#55bb8c",
    d: "M13.5,27A1.5,1.5,0,0,1,12,28.5H5.5v3H.5v-7a1.955,1.955,0,0,1,.59-1.41A1.955,1.955,0,0,1,2.5,22.5H4.8a1.986,1.986,0,0,1,1.25.44l3.2,2.56H12A1.5,1.5,0,0,1,13.5,27Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#57565d",
    d: "M7.19,15.57,2.5,16.5v2H.84A3.406,3.406,0,0,1,.5,17a3.5,3.5,0,0,1,6.69-1.43Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd9aa",
    d: "M24.5,17a3.492,3.492,0,0,0,6.65,1.5h.01A3.406,3.406,0,0,0,31.5,17a3.5,3.5,0,0,0-6.69-1.43A3.432,3.432,0,0,0,24.5,17Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#57565d",
    d: "M24.81,15.57l4.69.93v2h1.66A3.406,3.406,0,0,0,31.5,17a3.5,3.5,0,0,0-6.69-1.43Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#82c8ec",
    d: "M31.5,24.5v7h-5v-3H20a1.5,1.5,0,0,1,0-3h2.75l3.2-2.56a1.986,1.986,0,0,1,1.25-.44h2.3a2.015,2.015,0,0,1,2,2Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 3,
    x: 5.5,
    y: 28.5,
    fill: "#57565d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd9aa",
    d: "M13.5 27A1.5 1.5 0 0 1 12 28.5H10.5v-3H12A1.5 1.5 0 0 1 13.5 27zM21.5 25.5v3H20a1.5 1.5 0 0 1 0-3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5,6h5a.5.5,0,0,0,0-1h-5a.5.5,0,0,0,0,1Zm10,1h1.321a.5.5,0,0,1,.425.237l.478.772a1.5,1.5,0,0,0,2.552,0l.478-.772A.5.5,0,0,1,18.179,7H19.5A1.5,1.5,0,0,0,21,5.5v-4A1.5,1.5,0,0,0,19.5,0h-7A1.5,1.5,0,0,0,11,1.5v4A1.5,1.5,0,0,0,12.5,7ZM12,1.5a.5.5,0,0,1,.5-.5h7a.5.5,0,0,1,.5.5v4a.5.5,0,0,1-.5.5H18.179a1.49,1.49,0,0,0-1.276.711l-.478.772a.5.5,0,0,1-.851,0L15.1,6.711A1.49,1.49,0,0,0,13.821,6H12.5a.5.5,0,0,1-.5-.5ZM13.5,3h5a.5.5,0,0,0,0-1h-5a.5.5,0,0,0,0,1Zm0,2h5a.5.5,0,0,0,0-1h-5a.5.5,0,0,0,0,1Zm16,0h-5a.5.5,0,0,0,0,1h5a.5.5,0,0,0,0-1Zm2.1,13.7.007-.012A3.956,3.956,0,0,0,32,17a3.991,3.991,0,0,0-7.6-1.718c-.007.01-.011.022-.017.032a3.94,3.94,0,0,0,1.624,5.135A.474.474,0,0,0,26,20.5v1.809a2.491,2.491,0,0,0-.36.239L23,24.66V24.5a5.506,5.506,0,0,0-5-5.475c0-.009,0-.017,0-.025V17.5a.474.474,0,0,0-.01-.051,4,4,0,1,0-3.979,0A.474.474,0,0,0,14,17.5V19c0,.009,0,.017,0,.025A5.506,5.506,0,0,0,9,24.5v.16L6.36,22.548A2.491,2.491,0,0,0,6,22.309V20.5a.474.474,0,0,0-.01-.051,3.94,3.94,0,0,0,1.625-5.134c-.007-.011-.011-.023-.018-.034a3.987,3.987,0,1,0-7.208,3.41L.4,18.7A4,4,0,0,0,2.01,20.449.474.474,0,0,0,2,20.5v1.551A2.5,2.5,0,0,0,0,24.5v7a.5.5,0,0,0,.5.5h31a.5.5,0,0,0,.5-.5v-7a2.5,2.5,0,0,0-2-2.449V20.5a.474.474,0,0,0-.01-.051A4,4,0,0,0,31.6,18.7ZM16,11a3,3,0,0,1,2.791,1.921l-2.516-.715a2.516,2.516,0,0,0-1.618.086l-1.432.578A3,3,0,0,1,16,11Zm-3,3a.5.5,0,0,0,.187-.036l1.844-.744A1.51,1.51,0,0,1,16,13.168l2.861.813a.492.492,0,0,0,.136.01V14a3,3,0,0,1-6,0Zm4,3.858V19a1,1,0,0,1-2,0V17.858a3.591,3.591,0,0,0,2,0ZM10,24.5a4.5,4.5,0,0,1,4.29-4.479,1.984,1.984,0,0,0,3.421,0A4.5,4.5,0,0,1,22,24.5V25H20a1.986,1.986,0,0,0-1.721,3H13.722A1.992,1.992,0,0,0,12,25H10ZM21,26v2H20a1,1,0,1,1,0-2h1Zm-8,1a1,1,0,0,1-1,1H11V26h1a1,1,0,0,1,1,1ZM1,17a2.991,2.991,0,0,1,5.4-1.783l-4,.793a.5.5,0,0,0-.4.49V18H1.184A2.965,2.965,0,0,1,1,17Zm.78,2H2.5a.5.5,0,0,0,.5-.5V16.911l3.861-.766A2.958,2.958,0,0,1,7,17a2.989,2.989,0,0,1-5.22,2ZM5,20.858v1.159C4.933,22.012,4.866,22,4.8,22H3V20.858A3.954,3.954,0,0,0,4,21,3.954,3.954,0,0,0,5,20.858ZM5,28.5V31H1V24.5A1.5,1.5,0,0,1,2.5,23H4.8a1.5,1.5,0,0,1,.937.329l3.2,2.563A.5.5,0,0,0,9.251,26H10v2H8.667L4.8,25.1a.5.5,0,1,0-.6.8L7,28H5.5A.5.5,0,0,0,5,28.5ZM26,31H6V29H26Zm5-6.5V31H27V28.5a.5.5,0,0,0-.5-.5H25l2.8-2.1a.5.5,0,0,0-.6-.8L23.333,28H22V26h.749a.5.5,0,0,0,.313-.109l3.2-2.562A1.5,1.5,0,0,1,27.2,23h2.3A1.5,1.5,0,0,1,31,24.5Zm-4-2.483V20.858a3.591,3.591,0,0,0,2,0V22H27.2C27.134,22,27.067,22.012,27,22.017ZM28,20a3,3,0,0,1-3-3,2.958,2.958,0,0,1,.139-.855L29,16.911V18.5a.5.5,0,0,0,.5.5h.72A2.982,2.982,0,0,1,28,20Zm2-2V16.5a.5.5,0,0,0-.4-.49l-4-.793A2.983,2.983,0,0,1,30.816,18ZM29.5,7h-5a.5.5,0,0,0,0,1h5a.5.5,0,0,0,0-1Zm-28,3H2.821a.5.5,0,0,1,.425.237l.478.772a1.5,1.5,0,0,0,2.552,0l.478-.772A.5.5,0,0,1,7.179,10H8.5A1.5,1.5,0,0,0,10,8.5v-4A1.5,1.5,0,0,0,8.5,3h-7A1.5,1.5,0,0,0,0,4.5v4A1.5,1.5,0,0,0,1.5,10ZM1,4.5A.5.5,0,0,1,1.5,4h7a.5.5,0,0,1,.5.5v4a.5.5,0,0,1-.5.5H7.179A1.49,1.49,0,0,0,5.9,9.711l-.478.772a.5.5,0,0,1-.851,0L4.1,9.711A1.49,1.49,0,0,0,2.821,9H1.5A.5.5,0,0,1,1,8.5ZM30.5,3h-7A1.5,1.5,0,0,0,22,4.5v4A1.5,1.5,0,0,0,23.5,10h1.321a.5.5,0,0,1,.425.237l.478.772a1.5,1.5,0,0,0,2.552,0l.478-.772A.5.5,0,0,1,29.179,10H30.5A1.5,1.5,0,0,0,32,8.5v-4A1.5,1.5,0,0,0,30.5,3ZM31,8.5a.5.5,0,0,1-.5.5H29.179a1.49,1.49,0,0,0-1.276.711l-.478.772a.5.5,0,0,1-.851,0L26.1,9.711A1.49,1.49,0,0,0,24.821,9H23.5a.5.5,0,0,1-.5-.5v-4a.5.5,0,0,1,.5-.5h7a.5.5,0,0,1,.5.5ZM2.5,8h5a.5.5,0,0,0,0-1h-5a.5.5,0,0,0,0,1Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanel);
export default __webpack_public_path__ + "static/media/panel.1c2d2a34e30b9d558b58ea355ea98eb8.svg";
export { ForwardRef as ReactComponent };